import { useMemo, useRef } from "react";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import type { MarkdownMessageProps } from "app/pages/sales-intelligence/modules/ai-agent/components/MarkdownMessage/types";
import { useStructuredBrief } from "app/pages/sales-intelligence/modules/ai-agent/hooks/useStructuredBrief";

import { getBaseMarkdownComponents } from "../../utils/markdownComponents";

export const MeetingAgentMessage = ({
    content,
    components: customComponents,
    componentProps = {},
    collapseStatus,
    setCollapseStatus,
    isLoading,
}: MarkdownMessageProps) => {
    const components = useMemo(
        () => (customComponents ? customComponents : getBaseMarkdownComponents(componentProps)),
        [componentProps, customComponents],
    );

    const ref = useRef<HTMLDivElement>(null);
    const { structuredBrief } = useStructuredBrief({
        childrenRef: ref,
        collapseStatus,
        setCollapseStatus,
        isLoading,
        enabled: !componentProps.disableStructuredBrief,
    });

    if (!componentProps.disableStructuredBrief && structuredBrief) {
        return <div>{structuredBrief}</div>;
    }

    return (
        <div ref={ref}>
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={components}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};
